import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 13L2.64645 12.6464L2.5 12.7929V13H3ZM13 3L13.3536 2.64645C13.1583 2.45118 12.8417 2.45118 12.6464 2.64645L13 3ZM17 7L17.3536 7.35355C17.5488 7.15829 17.5488 6.84171 17.3536 6.64645L17 7ZM7 17V17.5H7.20711L7.35355 17.3536L7 17ZM3 17H2.5C2.5 17.2761 2.72386 17.5 3 17.5V17ZM3.35355 13.3536L13.3536 3.35355L12.6464 2.64645L2.64645 12.6464L3.35355 13.3536ZM12.6464 3.35355L16.6464 7.35355L17.3536 6.64645L13.3536 2.64645L12.6464 3.35355ZM16.6464 6.64645L6.64645 16.6464L7.35355 17.3536L17.3536 7.35355L16.6464 6.64645ZM7 16.5H3V17.5H7V16.5ZM3.5 17V13H2.5V17H3.5Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EditIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "edit",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})